import React, { useContext } from 'react'

import WellExplorer from './wells/Explorer'
import SampleExplorer from './samples/Explorer'
import Map from './map/Map'
import WellDetail from './wellDetail/Detail'
import Aggregate from './aggregate/Aggregate'
import { AppStateContext } from './AppStateContext'

const Explorer = () => {
    return (
        <div className="spaWrapper">
            <WellDetail />
            <div className="columns spaContainer is-full is-multiline is-1 is-variable">
                <div className="column is-one-third-desktop is-full-tablet is-full-mobile">
                    <SampleExplorer width={'one-third'} />
                    <Aggregate width={'one-third'} />
                </div>
                <div className="column is-two-thirds-desktop is-full-tablet is-full-mobile">
                    <Map width={'full'} />
                    <WellExplorer width={'full'} />
                </div>
            </div>
        </div>
    )
}

export default Explorer
